import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useExperimentMetrics } from '@experiment-details/api';
import { DEFAULT_CHART_TEMPLATE_NAME } from '@experiment-management-shared/constants/chartConstants';

import { snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import { calculatePanelsCount } from '@experiment-management-shared';
import useExpDetailsSelectedTemplate from '@experiment-details/hooks/useExpDetailsSelectedTemplate';

// Edge Case: If a user views an experiment before logging any metrics
// and then begins logging metrics, the view will not automatically update.
// This checks that the user is viewing the auto-generated chart template, and
// that there are now metrics available for the experiment before prompting.
const useExperimentHasNewPanelsMessage = ({
  experimentKey,
  isActive
}: {
  experimentKey: string;
  isActive?: boolean;
}) => {
  const dispatch = useDispatch();
  const { templateData } = useExpDetailsSelectedTemplate();
  const currentTemplate = templateData?.chartTemplate;
  const { data: metrics } = useExperimentMetrics({ experimentKey, isActive });

  useEffect(() => {
    if (!metrics || !currentTemplate) return;

    const isAutoGeneratedView =
      currentTemplate.template_name === DEFAULT_CHART_TEMPLATE_NAME;

    const panelNumber = calculatePanelsCount(currentTemplate.panels.sections);

    if (panelNumber === 0 && isAutoGeneratedView && metrics.length > 0) {
      dispatch(
        alertsUtil.openSnackbarDialog(
          snackbarTypes.CHARTS_AVAILABLE,
          'Your experiment has new panels. Refresh the page to view.'
        )
      );
    }
  }, [currentTemplate, dispatch, experimentKey, metrics]);
};

export default useExperimentHasNewPanelsMessage;
